// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","imageContainer":"DesktopListingDetailsImage_imageContainer__U8J0d","heroImage":"DesktopListingDetailsImage_heroImage__D693G"};